/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){

$(document).on('click','.bottom_content a,.review_shop-now .shop-button a',function(){
  var feature_id = $('.custom_feature_product:visible').attr('id');
  
  if (feature_id) {
      document.getElementById(feature_id).scrollIntoView({
          behavior: 'smooth', // for a smooth scrolling effect
          block: 'start'      // aligns the top of the element to the top of the viewport
      });
  }
});

$('.custom_main_slider').slick({
  slidesToShow: 1,
  autoplay: true,
  slidesToScroll: 1,
  autoplay: false,
  asNavFor: '.custom_main_slider_nav',
  adaptiveHeight: true
});

$('.custom_main_slider_nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  asNavFor: '.custom_main_slider',
  focusOnSelect: true,
  adaptiveHeight: true,
  arrows: true,
  responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow:4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow:3,
        }
      }
    ]
});
  
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();

  //choose option
  $(document).on('click','.chooseOptionDiv.feature_pro a',function(){
    var pro_id = $(this).parent('.customButton').attr('data-pro-id');
    if(pro_id){
      $('.custom_feature_product').addClass('hidden');
      $('.custom_feature_product[data-pro-id="'+pro_id+'"]').removeClass('hidden');
      var sec_id = $('.custom_feature_product[data-pro-id="'+pro_id+'"]').attr('id');
      if (sec_id) {
            document.getElementById(sec_id).scrollIntoView({
                behavior: 'smooth', // for a smooth scrolling effect
                block: 'start'      // aligns the top of the element to the top of the viewport
            });
        }

        // Destroy the existing sliders
        $('.custom_main_slider').slick('unslick');
        $('.custom_main_slider_nav').slick('unslick');
        
        // Reinitialize the sliders with the same settings
        $('.custom_main_slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          asNavFor: '.custom_main_slider_nav',
          adaptiveHeight: true
        });
        
        $('.custom_main_slider_nav').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          asNavFor: '.custom_main_slider',
          focusOnSelect: true,
          adaptiveHeight: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
              }
            }
          ]
        });

    }
  });
  
  $(document).on('click','.multi_variant_block .multi_variant_block_qty_box .qty_btn',function(){
      var qty_value = parseInt($(this).siblings('.multi_variant_qty_input').val());
    
      var new_qty = qty_value;
      if($(this).hasClass('minus_btn')){
        if(qty_value != 0){
          var new_qty = qty_value - 1;
          $(this).siblings('.multi_variant_qty_input').val(new_qty);
        }
      }else{
        var max_qty = parseInt($(this).siblings('.multi_variant_qty_input').attr('max'));
        if(qty_value != max_qty){
          var new_qty = qty_value + 1;
          $(this).siblings('.multi_variant_qty_input').val(new_qty);
        }
      }

      if(new_qty > 0){
        $(this).parents('.multi_variant_block').addClass('added');
      }else{
        $(this).parents('.multi_variant_block').removeClass('added');
      }

      var total_added_var_length = $(this).parents('.multi_variant_top').find('.multi_variant_block.added').length;
    
      var total_qty = 0;
      var compare_price = 0;
      var price = 0;
      for(i=0;i<total_added_var_length;i++){
        var var_qty = parseInt($(this).parents('.multi_variant_top').find('.multi_variant_block.added').eq(i).find('.multi_variant_qty_input').val());
        var pro_price = parseInt($(this).parents('.multi_variant_top').find('.multi_variant_block.added').eq(i).attr('data-price'));
        var pro_compare_price = parseInt($(this).parents('.multi_variant_top').find('.multi_variant_block.added').eq(i).attr('data-compare-price'));

        var final_price = pro_price * var_qty;
        var final_compare_price = pro_compare_price * var_qty;
        
        var total_qty = total_qty + var_qty;
        var price = price + final_price;
        var compare_price = compare_price + final_compare_price;
      }

      if(compare_price > price){
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_subtotal_price .multi_variant_subtotal_compare_price').show();
      }
      $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_subtotal_label .multi_variant_totalquantity').html(total_qty);
      $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .pending_quantity .selected_count').html(total_qty);
      $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_subtotal_price .multi_variant_subtotal_price span').html(Currency.formatMoney(price, window.theme.moneyFormat));
      $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_subtotal_price .multi_variant_subtotal_compare_price span').html(Currency.formatMoney(compare_price, window.theme.moneyFormat));
    
      var total_max_qty = parseInt($(this).parents('.multi_variant_custom').find('.multi_variant_add_to_cart_button_block button').attr('data-box-qty'));

      console.log(total_max_qty);
    console.log(total_qty);
      if(total_qty == total_max_qty){
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .pending_quantity').addClass('hidden');        
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .adding_more').addClass('hidden');
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .matched_added').removeClass('hidden');
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .matched_added .selected_variant_count').html(total_added_var_length);
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_add_to_cart_button_block button').removeAttr('disabled');
      }else if(total_qty > total_max_qty){
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .pending_quantity').addClass('hidden');
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .adding_more').removeClass('hidden');
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .matched_added').addClass('hidden');
        $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_add_to_cart_button_block button').attr('disabled','disabled');
      }else{
        if(total_max_qty > total_qty){
          var minus_qty = total_max_qty - total_qty;
          $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .pending_quantity').removeClass('hidden');
          $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .pending_quantity .selected_count').html(total_qty);
          $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .adding_more').addClass('hidden');
          $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_setbox_alert .matched_added').addClass('hidden');
          $(this).parents('.multi_variant_custom').find('.multi_variant_footer .multi_variant_add_to_cart_button_block button').attr('disabled','disabled');
        }
      }
  });

  //ATC click
  $(document).on('click','.multi_variant_custom .multi_variant_footer .multi_variant_add_to_cart_button_block button',function(){
    let arrPdp = [];
    var totalLi = $(this).parents('.multi_variant_custom').find('.multi_variant_top .multi_variant_block.added').length;
    $(this).parents('.multi_variant_custom').find('.multi_variant_top .multi_variant_block.added').each(function(index){
      var variant_id = $(this).attr('data-var-id');
      var variant_qty = parseInt($(this).find('.multi_variant_qty_input').val());
      if($(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-subscription-visible').length > 0){
        var property_name_1 = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-subscription-visible').attr('name');
        var property_name_1_val = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-subscription-visible').val();
        var property_name_2 = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-discount-value-visible').attr('name');
        var property_name_2_val = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-discount-value-visible').val();

        var propertyName_1 = property_name_1.match(/\[([^\]]+)\]/)[1];
        var propertyName_2 = property_name_2.match(/\[([^\]]+)\]/)[1];


        var property_name_3 = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-interval').attr('name');
        var propertyName_3 = property_name_3.match(/\[([^\]]+)\]/)[1];
        var property_name_3_val = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-interval').val();
        
        var property_name_4 = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-id').attr('name');
        var propertyName_4 = property_name_4.match(/\[([^\]]+)\]/)[1];
        var property_name_4_val = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-id').val();
        
        var property_name_5 = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-discount-value').attr('name');
        var propertyName_5 = property_name_5.match(/\[([^\]]+)\]/)[1];
        var property_name_5_val = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-discount-value').val();
        
        var property_name_6 = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-discount-value-hash').attr('name');
        var propertyName_6 = property_name_6.match(/\[([^\]]+)\]/)[1];
        var property_name_6_val = $(this).parents('.ProductForm').find('.sealsubs-target-element .sls-option-container.sls-active .sls-input-discount-value-hash').val();
      }
      if(propertyName_1){        
        // arrPdp.push({id: variant_id, quantity: variant_qty,properties: {[propertyName_1]: property_name_1_val, [propertyName_2]: property_name_2_val }});        
          arrPdp.push({id: variant_id, quantity: variant_qty,properties: {[propertyName_1]: property_name_1_val, [propertyName_2]: property_name_2_val,[propertyName_3]: property_name_3_val,[propertyName_4]: property_name_4_val,[propertyName_5]: property_name_5_val,[propertyName_6]: property_name_6_val }});        
      }else{
        arrPdp.push({id: variant_id, quantity: variant_qty});
      }

      console.log(arrPdp);
      let formData = {'items': arrPdp};
      if(index === totalLi - 1){
        add_bundle(formData);
      }
    });
  });

  function add_bundle(formData){
      fetch('/cart/add.js', {
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
        }).then((response) => {
        return response.json();
        }).then((res) => {
           // response here
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true  //this code is for prestige theme, is to refresh the cart
          }));

          window.location.href = '/cart';
          // var cartDrawerButtonSelector = "a.Header__Icon[data-action='open-drawer']";
          // var cartDrawerButton = document.querySelector(cartDrawerButtonSelector);
          // setTimeout(function() {
          // $('.product_right_wrpper .article_wrpper .add_to_cart_btn').removeClass('loading');
          // $('.product_right_wrpper .selected_group .selected_addtocart').removeClass('loading');
          // cartDrawerButton.click();
          // }, 1000);
       }).catch((err) => {
        $('.product_right_wrpper .article_wrpper .add_to_cart_btn').removeClass('loading');
        $('.product_right_wrpper .selected_group .selected_addtocart').removeClass('loading');
        /* uh oh, we have error. */ console.error(err)
      });
  }
});
